export type StageModule = 'contractor' | 'customer';
export type StageItemType = 'info' | 'note' | 'checklist' | 'text' | 'textarea' | 'number' | 'date' | 'datetime' | 'select' | 'radio' | 'checkboxes' | 'yes_no';

export interface StageItem {
  key: string;
  type: StageItemType;
  label: string;
  required?: boolean;
  help?: string;
  message?: string;
  options?: string[];
  checklist?: string[];
  /** record column the answer also updates (see the API's CrmStageRequirementService::MAPPABLE) */
  maps_to?: string;
  /** only shown (and required) when another answer matches */
  show_if?: { key: string; op: 'equals' | 'not_equals' | 'contains' | 'is_not_empty'; value?: string };
}

/** Questions asked when a record moves into a stage - Zoho Blueprint / HubSpot required properties. */
export interface StageRequirement {
  id?: number;
  module: StageModule;
  stageKey: string;
  /** null = coming from any stage */
  fromStages: string[] | null;
  title: string;
  description: string | null;
  items: StageItem[];
  isActive: boolean;
  source?: string;
  mappableFields?: string[];
}

export const STAGE_ITEM_TYPE_LABELS: Record<StageItemType, string> = {
  info: 'Info text (no answer)',
  note: 'Note',
  checklist: 'Checklist',
  text: 'Short text',
  textarea: 'Long text',
  number: 'Number',
  date: 'Date',
  datetime: 'Date & time',
  select: 'Dropdown',
  radio: 'Single choice',
  checkboxes: 'Multiple choice',
  yes_no: 'Yes / No'
};

export const STAGE_MAPPABLE_LABELS: Record<string, string> = {
  monthly_recurring_revenue: 'Deal amount (monthly)', abn_acn: 'ABN / ACN', deal_type: 'Deal type', monthly_volume: 'Monthly volume',
  despatch_locations: 'Despatch locations', sends_dangerous_goods: 'Sends dangerous goods', requires_integration: 'Requires integration'
};

export function stageItemShown (item: StageItem, answers: Record<string, any>): boolean {
  const c = item.show_if;
  if (!c) return true;
  let a = answers[c.key];
  a = Array.isArray(a) ? a.join(', ') : String(a ?? '');
  const v = String(c.value ?? '');
  switch (c.op) {
    case 'equals': return a.toLowerCase() === v.toLowerCase();
    case 'not_equals': return a.toLowerCase() !== v.toLowerCase();
    case 'contains': return v !== '' && a.toLowerCase().includes(v.toLowerCase());
    case 'is_not_empty': return a !== '';
  }
  return true;
}
